// Hero Video Section Script
(function($) {
  'use strict';

  const HeroVideoSection = {
    // Initialize
    init() {
      this.cacheSelectors();
      this.bindEvents();
      this.setupVideoPreview();
    },

    // Cache jQuery selectors
    cacheSelectors() {
      this.$section = $('#heroVideoSection');
      this.$videoBtn = $('#heroVideoBtn');
      this.$videoPreview = $('#heroVideoPreview');
      this.videoUrl = this.$section.data('video-url');
            this.videoUrl2 = this.$section.data('video-url2');

    },

    // Bind event handlers
    bindEvents() {
      const self = this;

      // Video button click - dispatch custom event for modal
      this.$videoBtn.on('click', function(e) {
        e.preventDefault();
        self.openVideoModal();
      });

      // Hover states for video preview
      this.$videoBtn.on('mouseenter', function() {
        self.startVideoPreview();
      });

      this.$videoBtn.on('mouseleave', function() {
        self.stopVideoPreview();
      });
    },

    // Setup video preview element
    setupVideoPreview() {
      if (!this.videoUrl) return;

      const videoHTML = `
        <video 
          playsinline 
          muted 
          loop 
          preload="none"
          style="width: 100%; height: 100%; object-fit: cover;"
        >
          <source src="${this.videoUrl2}" type="video/mp4">
        </video>
      `;

      this.$videoPreview.html(videoHTML);
      this.$video = this.$videoPreview.find('video')[0];
    },

    // Start video preview on hover
    startVideoPreview() {
      if (!this.$video) return;

      this.$video.currentTime = 0;
      this.$video.play().catch(() => {
        console.log('Video autoplay prevented');
      });
    },

    // Stop video preview on hover out
    stopVideoPreview() {
      if (!this.$video) return;
      this.$video.pause();
      this.$video.currentTime = 0;
    },

    // Open video modal
    openVideoModal() {
         const videoHTML2 = `
        <video 
          playsinline
          autoplay="1"
          muted 
          loop 
          preload="none"
          style="width: 100%; height: 100%; object-fit: cover;"
        >
          <source src="${this.videoUrl}" type="video/mp4">
        </video>
      `;

      $(".video_container_wrap").html(videoHTML2);
        $("#sarisPopupOverlayCyclic").addClass('saris-active');
    //   // Dispatch custom event that parent/page can listen to
    //   const event = new CustomEvent('openVideoModal', {
    //     detail: {
    //       videoUrl: this.videoUrl
    //     }
    //   });
    //   document.dispatchEvent(event);

      // Alternative: If using a specific modal element, you can also trigger it here
      // Example: $('#videoModal').modal('show');
    }
  };

  // Initialize when document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      HeroVideoSection.init();
    });
  } else {
    HeroVideoSection.init();
  }

  // Also reinitialize on Shopify theme editor updates
  document.addEventListener('shopify:section:load', function() {
    HeroVideoSection.init();
  });

     $("div#sarisPopupOverlayCyclic button#sarisCloseBtn").on('click', function(e) {
                $("#sarisPopupOverlayCyclic").removeClass('saris-active');

      });
})(jQuery);
